import React from 'react';
import classNames from 'classnames';
import { CountryFlag, bemClasses } from 'project/country-flag';
import { playerSitecoreData } from 'components/live-player';

const LeaderboardWidgetNameContent = ({ player }) => {
    const sitecoreData = player.sitecoreData || playerSitecoreData;
    const stateCss = classNames({
        'is-long': sitecoreData.lastName && sitecoreData.lastName.length > 12
    });

    return (
        <div className={'leaderboard-widget__name-content'}>
            <CountryFlag
                childCss={'leaderboard-widget__country-flag'}
                image={sitecoreData.countryFlagSrc}
                bemList={[bemClasses.SMALL]}
            />
            {
                sitecoreData.lastName &&
                <div className="leaderboard-widget__name-content-last-name">{sitecoreData.lastName},</div>
            }
            {
                sitecoreData.firstName &&
                <div className="leaderboard-widget__name-content-first-name">{sitecoreData.firstName=="Sir Nick" ? "N" : sitecoreData.firstName.charAt(0)}</div>
            }
            {
                sitecoreData.isChampion &&
                <div className="leaderboard-widget__is-champion">
                    <svg className="leaderboard-widget__icon icon" width="24" height="26" focusable="false">
                        <use xlinkHref="#icon-symbol"></use>
                    </svg>
                </div>
            }
        </div>
    );
};

export default LeaderboardWidgetNameContent;
